import Backbone from 'backbone';
import ko from 'knockout';
import tmpl from '@bingads-webui-campaign-legacy/auto-targets/template/create/all-webpage.pug';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class View extends Backbone.View {
  get events() {
    return {
      'click .arrow-button': 'selectTarget',
    };
  }
  render() {
    this.$el.html(tmpl({
      i18n,
    }));
    ko.applyBindings(self.viewModel, this.el);
    return this;
  }
  show() {
    this.$el.show();
    return this;
  }
  hide() {
    this.$el.hide();
    return this;
  }
  selectTarget() {
    this.trigger('selectTarget', {
      conditions: [],
      type: 'allwebpage',
    });
  }
}
